import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './TS_Radio.scss';
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className, stopPropagation } from '../../utils/tools.js';
import { Label } from '../Label/Label.js';
import { exists } from '@nu-art/ts-common';
export class TS_Radio extends ComponentSync {
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps) {
        return {
            values: nextProps.values,
            checked: nextProps.checked,
            disabled: nextProps.disabled,
            labelTooltipContainerSelector: nextProps.labelTooltipContainerSelector
        };
    }
    // ######################### Logic #########################
    handleOptionClick = (e, value) => {
        stopPropagation(e);
        if (this.state.disabled)
            return;
        const prevValue = this.state.checked;
        const nextValue = (this.props.canUnselect && value === prevValue)
            ? undefined
            : value;
        if (this.props.onCheck)
            return this.props.onCheck(nextValue, prevValue);
        this.setState({ checked: nextValue });
    };
    // ######################### Render #########################
    renderRadioOption = (value) => {
        const className = _className('ts-radio__container', (value === this.state.checked ? 'checked' : ''));
        return _jsxs("label", { htmlFor: `${this.props.groupName}-${value}`, className: className, onClick: (e) => this.handleOptionClick(e, value), children: [this.renderRadioButton(value), this.renderRadioLabel(value)] }, String(value));
    };
    renderRadioLabel = (value) => {
        const renderer = this.props.labelRenderer ?? ((value) => String(value));
        const label = renderer(value);
        const labelTooltip = exists(this.props.labelTooltipResolver) ? this.props.labelTooltipResolver(value) : label;
        return _jsx(Label, { forceUpdate: true, className: 'ts-radio__label', tooltip: labelTooltip, containerSelector: this.state.labelTooltipContainerSelector, children: label });
    };
    renderRadioButton = (value) => {
        return _jsx("span", { className: 'ts-radio__button' });
    };
    render() {
        const className = _className('ts-radio', this.state?.disabled ? 'disabled' : undefined, this.props.className);
        return _jsx("div", { className: className, ref: this.props.innerRef, children: this.props.values.map(value => {
                return this.renderRadioOption(value);
            }) });
    }
}
//# sourceMappingURL=TS_Radio.js.map